var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLoginJoinIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 770 830",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.072 830H496.072L496.072 413H359.072L359.072 830Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496.703 274.754H632.912V137.766L496.703 137.766V274.754Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M632.072 830H769.072V413H632.072V830Z",
    fill: "#004899"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.379 410.185V273.197H0.120819V410.185H357.379Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.379 136.988V0L0.120819 0V136.988L357.379 136.988Z",
    fill: "#004899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLoginJoinIocn);
export default __webpack_public_path__ + "static/media/web-login-join-iocn.cf2cfaedf115270750d61571b354c958.svg";
export { ForwardRef as ReactComponent };